<div *ngIf="langs.length > 1" class="auth-lang-switch" role="group" aria-label="Language">
  <button *ngFor="let lang of langs"
          type="button"
          class="auth-lang-btn"
          [class.active]="currentLang() === lang"
          (click)="switch(lang)">
    {{ lang.toUpperCase() }}
  </button>
</div>
